export function convertDateTimeToCustomFormat(dateTimeString) {
    try {
        // Attempt to parse the input date string
        const date = new Date(dateTimeString);

        // Check if the date is invalid
        if (isNaN(date.getTime())) {
            throw new Error("Invalid date input");
        }

        // Format the date
        return formatDate(date);
    } catch (error) {
        // If there's an error, return the current date in the desired format
        const currentDate = new Date();
        return formatDate(currentDate);
    }
}

// Helper function to format a Date object as DD-MMM-YYYY
function formatDate(date) {
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
}

// // Example usage
// console.log(convertDateTimeToCustomFormat("2024-12-30 08:00:00")); // Output: 30-Dec-2024
// console.log(convertDateTimeToCustomFormat("invalid input"));       // Output: (current date in DD-MMM-YYYY format)
export function fullformatTimestamp(timestamp) {
    const daysOfWeek = [
      "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"
    ];
    const months = [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];
  
    try {
      const date = new Date(timestamp);
      if (isNaN(date)) throw new Error("Invalid date"); // Check if the date is invalid
  
      const dayOfWeek = daysOfWeek[date.getDay()];
      const day = date.getDate();
      const month = months[date.getMonth()];
      const year = date.getFullYear();
  
      let hours = date.getHours();
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const ampm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12 || 12; // Convert 24-hour time to 12-hour format
  
      return `${dayOfWeek}, ${day} ${month} ${year} ${hours}:${minutes} ${ampm}`;
    } catch (error) {
      return ""; // Return an empty string in case of an error
    }
  }
  
  const dob = "1967-06-28";

  export const formattedDob = (dateString) => {
    // Parse the date string as a UTC date
    const date = new Date(dateString);
    // Check if the date is invalid
    if (isNaN(date.getTime())) {
      return ""; // Return empty string for invalid date
    }
  
    // Format the date to "dd-MMM-yyyy" format
    return new Intl.DateTimeFormat("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      timeZone: "UTC", // Ensure consistent timezone
    })
      .format(date)
      .replace(/ /g, ' ');
  };
  
// dateFormatter.js wednesday,march 18,2024
export const formatDdmmyyyyy = (date) => {
  if (!date) return "Invalid date"; // Handle empty input

  const parsedDate = new Date(date);
  if (isNaN(parsedDate.getTime())) return "Invalid date"; // Handle incorrect date input

  return parsedDate.toLocaleDateString("en-US", {
    weekday: "long",
    month: "long",
    day: "numeric",
    year: "numeric",
  });
};
export const formatDdmmyyyy = (date) => {
  if (!date) return "Invalid date"; // Handle empty input

  const parsedDate = new Date(date);
  if (isNaN(parsedDate.getTime())) return "Invalid date"; // Handle incorrect date input

  return parsedDate.toLocaleDateString("en-US", {

    month: "long",
    day: "numeric",
    year: "numeric",
  });
};



  

  